import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-confirmation-modal-file',
  templateUrl: './confirmation-modal-file.component.html',
  styleUrls: ['./confirmation-modal-file.component.css']
})
export class ConfirmationModalFileComponent implements OnInit {

  title = 'Confirmar acción';
  message = 'La siguiente acción no se puede deshacer. ¿Está seguro?';
  cancelButtonText = 'Cancelar';
  continueButtonText = 'Continuar';
  continueButtonStyle = 'success';
  messages;
  role;
  order = true;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() { }

  get isPlanner() {
    return rolesUtils.isPlanner(this.role)
  }

  checkedOrder() {
    this.order = !this.order;
  }

  confirmAndDismiss(status) {
    this.activeModal.dismiss({ order: this.order, status: status });
  }
}
